module.exports = __webpack_public_path__ + "img/077990363cf25d0c4e1e4914ad18c86b.jpg";